import React from 'react'
import card from "../../../../assets/img/admin/card-pos.svg"
import arrowLeft from "../../../../assets/img/admin/arrow-left.svg"
const AdminJudjeCard = ({info}) => {
  return (
    <div className='AdminJudjeCard'>
      <div className={`center  w-[54px] h-[54px] rounded-[50%] bg-[#D6EDD7]`}>
        <img src={card}/>


      </div>
      <h4>درخواست باز پرداخت وجه اجاره</h4>
      <p className='AdminJudjeCard--des Danafont'>تاریخ درخواست :
<span>
22 بهمن 1359
</span>
       </p>
      <button className='flex gap-[6px] items-center'>
        <p>داوری شکایت</p>
        <img src={arrowLeft}/>

      </button>
    </div>
  )
}

export default AdminJudjeCard